<template>
  <div>
    <Head :title="__('Create New Knowledge Base Category')" />
    <div class="bg-white rounded-md shadow overflow-hidden max-w-full">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.name" :error="form.errors.name" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Category Name')" />

          <select-input v-model="form.parent_id" :error="form.errors.parent_id" class="pr-6 pb-8 w-full lg:w-1/3" :label="__('Parent Category')">
            <option :value="null">{{ __('No Parent') }}</option>
            <option v-for="category in categories" :key="category.id" :value="category.id">{{ category.name }}</option>
          </select-input>
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">{{ __('Create Category') }}</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import { Link, Head } from '@inertiajs/vue3'

export default {
  metaInfo: { title: 'Create New Knowledge Base Category' },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    Link,
    Head,
  },
  layout: Layout,
  props: {
    categories: Array,
    parent: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: '',
        parent_id: this.parent.id,
      }),
    }
  },
  methods: {
    store() {
      this.form.post(this.route('knowledge_base_categories.store'))
    },
  },
}
</script>